import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as resultCodes from "../constants/resultCodes";
import * as methods from "../constants/methods";
import * as rcc from "../constants/rcc";
import * as handlers from "../constants/handlers";
import * as settings from "../constants/settings";
import * as resources from "../constants/resources";
import * as rccHelper from "../helpers/rccResponseHelper";
import * as messageHelper from "../helpers/messageHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as responseHelper from "../helpers/responseHelper";
import * as getterHelper from "../helpers/getterHelper";
import * as initService from "./rccResponseService/initService";
import * as autotaskService from "./rccResponseService/autotaskService";
import * as spectroService from "./rccResponseService/spectroService";
import * as windowService from "./windowService";
import * as stockActions from "../actions/stockActions";

export const processWebsocketResponse = (tabId, method, response, next, state) => {
    switch (method) {
        case handlers.MACHINE_CONNECTION_TEST:
            if (response.result === resultCodes.RCC_RESULT_OK && response.data === true) {
                if (next !== null) {
                    return [next];
                }

                return [];
            }

            return [
                {
                    type: actionTypes.MACHINE_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                },
                messageHelper.getWarningMessageAction("flashMessage.machineIsNotConnected")
            ];
        case handlers.MACHINE_GET_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (state.settings.overwriteMachineConfig) {
                let syncAction = getterHelper.synchronizeMachineConfigurationToServer(
                    response.data,
                    state.settings.rccBarcodeRefill,
                    state.settings.rccBaseCanBarcodeValidation,
                    state.settings.rccCheckCanBeforeDispense,
                    state.settings.rccCheckOverfill,
                    state.settings.rccDispenseInvalidColorants,
                    state.settings.rccManualColorantAddition,
                    state.settings.rccMinimalDispenseAmount,
                    state.settings.rccPlaceCanSensor,
                    state.settings.rccPlaceCanSensorDelay,
                    state.settings.rccRemoveCanSensor,
                    state.settings.rccRemoveCanSensorDelay,
                    state.settings.rccSkipPlaceCanDialog,
                    state.settings.rccSkipRemoveCanDialog,
                    state.settings.rccSplitFormula,
                    state.settings.rccTmcEnabled,
                    state.settings.rccUnit,
                    state.settings.rccValidateColorantsDuringInit
                );

                if (syncAction !== null) {
                    return [
                        {
                            type: actionTypes.SAVE_MACHINE_CONFIGURATION_AND_RELOAD_CANISTERS,
                            payload: {
                                machineConfigurationList: response.data
                            }
                        },
                        syncAction
                    ];
                }
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_CONFIGURATION_AND_RELOAD_CANISTERS,
                    payload: {
                        machineConfigurationList: response.data
                    }
                }
            ];
        case handlers.SET_DRIVER_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DRIVER_CONFIGURATION
                    },
                    method: handlers.GET_DRIVER_CONFIGURATION,
                    tabId: 0
                }
            ];
        case handlers.GET_DRIVER_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (state.rcc.machine.isConnected) {
                return [
                    {
                        type: actionTypes.SAVE_MACHINE_DRIVER_CONFIGURATION,
                        payload: {
                            configuration: response.data
                        }
                    },
                    {
                        type: actionTypes.MACHINE_SAVE_DRIVER_RECONNECT,
                        payload: {
                            reconnectMachine: true
                        }
                    },
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_START_DISCONNECT
                        },
                        method: handlers.MACHINE_START_DISCONNECT,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            if (
                typeof response.data === "object" &&
                response.data !== null &&
                typeof response.data.General === "object" &&
                response.data.General !== null &&
                response.data.General.type === rcc.DRIVER_TYPE_NONE
            ) {
                return [
                    {
                        type: actionTypes.SAVE_MACHINE_DRIVER_CONFIGURATION,
                        payload: {
                            configuration: response.data
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_DRIVER_CONFIGURATION,
                    payload: {
                        configuration: response.data
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_START_CONNECT
                    },
                    method: handlers.MACHINE_START_CONNECT,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.MACHINE_SET_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CONFIGURATION
                    },
                    method: handlers.MACHINE_GET_CONFIGURATION,
                    tabId: 0
                }
            ];
        case handlers.INTERGAMMA_MACHINE_SET_DISPENSE_LEVEL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CONFIGURATION
                    },
                    method: handlers.MACHINE_GET_CONFIGURATION,
                    tabId: 0
                }
            ];
        case handlers.MACHINE_START_CONNECT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_CONNECT_DONE
                    }
                },
                messageHelper.getInfoMessageAction("flashMessage.machineIsConnecting")
            ];
        case handlers.MACHINE_CANISTERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_CANISTERS,
                    payload: {
                        canisterList: modelHelper.mapCanistersToObjects(
                            response.data,
                            state.global.allColorantList,
                            state.rcc.canisterList
                        )
                    }
                }
            ];
        case handlers.MACHINE_START_INITIALIZE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_INITIALIZE_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_RESET:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_RESET_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_HARD_RESET:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_HARD_RESET_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_DISCONNECT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_DISCONNECT_DONE
                    }
                }
            ];
        case handlers.SPECTRO_START_DISCONNECT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.SPECTRO_EVENT_DISCONNECT_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_ERRORS_RESET:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }
            let startErrorsResetRequests = [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_ERRORS_RESET_DONE
                    }
                }
            ];

            if (state.rcc.machine.dialog !== null) {
                startErrorsResetRequests.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                        params: {
                            dialogID: state.rcc.machine.dialog.id,
                            msgBtn: rcc.RCC_BTN_OK
                        }
                    },
                    method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                    tabId: 0,
                    safe: false
                });
            }

            return startErrorsResetRequests;
        case handlers.MACHINE_VALIDATE_FORMULA:
            if (!responseHelper.isValidateFormulaFormatValid(response)) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.MACHINE_SAVE_VALIDATION_RESULT,
                    payload: {
                        tabId: tabId,
                        result: response.data,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            response.data[2],
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                }
            ];
        case handlers.MACHINE_VALIDATE_FORMULA_AND_LOAD_MANUAL:
            if (!responseHelper.isValidateFormulaFormatValid(response)) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.MACHINE_SAVE_VALIDATION_RESULT,
                    payload: {
                        tabId: tabId,
                        result: response.data,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            response.data[2],
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_MANUAL_FORMULA,
                        params: {
                            formula:
                                state.formula[tabId] !== undefined && state.formula[tabId].formula !== null
                                    ? state.formula[tabId].formula.getColorantVolumes()
                                    : []
                        }
                    },
                    method: handlers.MACHINE_MANUAL_FORMULA,
                    tabId: tabId,
                    safe: true
                }
            ];
        case handlers.MACHINE_START_DISPENSE_FORMULA:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    messageHelper.getRccFlashMessage(response),
                    {
                        type: actionTypes.UPDATE_DISPENSING_INFO,
                        payload: {
                            tabId: tabId,
                            numCanDone: null,
                            numCanTotal: null,
                            dispensing: false
                        }
                    },
                    {
                        type: actionTypes.POP_DISPENSING_FORMULA
                    }
                ];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.UPDATE_DISPENSING_INFO,
                        payload: {
                            tabId: tabId,
                            numCanDone: null,
                            numCanTotal: null,
                            dispensing: true
                        }
                    },
                    {
                        type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                        payload: {
                            id: response.sequence,
                            tabId: tabId,
                            method: methods.MACHINE_EVENT_DISPENSE_FORMULA_DONE
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.UPDATE_DISPENSING_INFO,
                    payload: {
                        tabId: tabId,
                        numCanDone: null,
                        numCanTotal: null,
                        dispensing: false
                    }
                },
                {
                    type: actionTypes.POP_DISPENSING_FORMULA
                }
            ];
        case handlers.MACHINE_GET_ERRORS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === undefined) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_ERRORS,
                    payload: {
                        errors: response.data
                    }
                }
            ];
        case handlers.MACHINE_GET_ERROR_DETAILS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            window.imageStore.setMachineError(null);

            if (response.data !== undefined && response.data.imagePresent && state.rcc.machine.isConnected) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_ERROR_IMAGE,
                            params: {
                                dispenserType: state.rcc.machine.type,
                                code: response.data.code
                            }
                        },
                        method: handlers.MACHINE_GET_ERROR_IMAGE,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [];
        case handlers.MACHINE_GET_ERROR_IMAGE:
            if (response.result !== resultCodes.RCC_RESULT_OK || response.data === undefined) {
                window.imageStore.setMachineError(null);

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            window.imageStore.setMachineError({
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.MACHINE_GET_DIALOG:
        case handlers.MACHINE_GET_DIALOG_AND_SKIP_BARCODE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return rccHelper.processDialogResponse(method, response.data, state);
        case handlers.MACHINE_GET_DIALOG_AND_CONTINUE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                        params: {
                            dialogID: response.data.dialogID,
                            msgBtn: rcc.RCC_BTN_CONTINUE
                        }
                    },
                    method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.MACHINE_DIALOG_BUTTON_CLICK:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case handlers.MACHINE_MOVE_TABLE_TO_REFILL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_MOVE_TABLE_TO_REFILL_DONE
                    }
                }
            ];
        case handlers.MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE:
        case handlers.MACHINE_SET_MAX_DISPENSE_LEVEL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.MACHINE_SET_CANISTER_LEVEL:
        case handlers.MACHINE_ADD_CANISTER_LEVEL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            const actions = [
                {
                    type: actionTypes.MACHINE_RESET_REFILL_VALIDATION
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                }
            ];

            if (
                state.login.loggedUser.canRead(resources.COMPONENT_COLORANT_STOCK_MODAL) &&
                state.rcc.machine.refillValidation?.colorantPackage?.id
            ) {
                actions.push(
                    stockActions.removeColorantPackage(
                        modelHelper.buildColorantPackageStock(
                            state.rcc.machine.refillValidation.colorantPackage.id,
                            state.rcc.machine.refillValidation.colorantPackage.name,
                            state.rcc.machine.refillValidation.colorantPackage.colorantName
                        ),
                        false,
                        true
                    )
                );
            }

            if (state.settings.colorantBatchNumbers !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
                actions.push({
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTER_BATCH_NUMBERS
                    },
                    method: handlers.RELOAD_MACHINE_CAN_BATCH_NUMBERS,
                    tabId: 0,
                    safe: true
                });
            }

            return actions;
        case handlers.MACHINE_SET_CANISTER_UFI_CODE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.SET_CANISTER_UFI_CODE_MODAL
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.MACHINE_START_SHELF:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_SHELF_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_PUNCH:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_PUNCH_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_PLUG:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_PLUG_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_CAP:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_CAP_DONE
                    }
                }
            ];
        case handlers.MACHINE_SHOW_SERVICE_WINDOW:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_SERVICE_WINDOW_DONE
                    }
                },
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: true
                    }
                }
            ];
        case handlers.MACHINE_VALIDATE_QUICK_DISPENSE_FORMULA:
            if (!responseHelper.isValidateFormulaFormatValid(response)) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            let quickTint = state.rcc.dispensingFormula;

            if (quickTint === null || quickTint.formula === null) {
                return [];
            }

            let validatedFormula = quickTint.formula.validateColorants(response.data);

            let quickDispenseActions = [
                {
                    type: actionTypes.SAVE_DISPENSING_FORMULA,
                    payload: {
                        formula: validatedFormula,
                        base: quickTint.base,
                        moreInfoText: quickTint.moreInfoText,
                        dispenseNote: quickTint.dispenseNote,
                        moreInfoInternal: quickTint.moreInfoInternal,
                        buildingSite: null,
                        priceList: quickTint.priceList,
                        infoData: quickTint.infoData,
                        printData: quickTint.printData,
                        tmcData: quickTint.tmcData
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_FORMULA_META_AND_PRINT_DATA,
                        params: {
                            brand: state.server.activeDatabase.name,
                            formulaColorants: validatedFormula.getRealColorantAmounts(),
                            formulaCorrections: null,
                            unitId: 1,
                            packageCount: 1,
                            marginId: null,
                            marginLocal: null,
                            colorantUfiCodes: getterHelper.getFormulaUfiCodes(
                                quickTint.formula.colorantList,
                                state.rcc.canisterList,
                                state.settings.ufiCodeLogic
                            ),
                            baseInProductUfiCode: null,
                            colorantBatchNumbers: getterHelper.getFormulaColorantBatchNumbers(
                                quickTint.formula.colorantList,
                                state.rcc.canisterList
                            ),
                            canisterBatchNumbers: getterHelper.getFormulaCanisterBatchNumbers(
                                quickTint.formula.colorantList,
                                state.rcc.canisterList,
                                state.machine.allBatchNumbersList
                            )
                        }
                    },
                    method: handlers.GET_FORMULA_META_AND_DISPENSE,
                    tabId: tabId
                }
            ];

            if (tabId !== componentTypes.QUICK_TINT_TAB_ID) {
                quickDispenseActions.push({
                    type: actionTypes.MACHINE_SAVE_VALIDATION_RESULT,
                    payload: {
                        tabId: tabId,
                        result: response.data,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            response.data[2],
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                });
            }

            return quickDispenseActions;
        case handlers.MACHINE_START_CLEAN_CHANNELS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_CLEAN_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_CLEAN_ALL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_CLEAN_ALL_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_RECIRCULATE_CHANNELS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_RECIRCULATE_DONE
                    }
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.RECIRCULATE_CHANNELS_MODAL
                    }
                }
            ];
        case handlers.MACHINE_START_RECIRCULATE_ALL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_RECIRCULATE_ALL_DONE
                    }
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.RECIRCULATE_ALL_CHANNELS_MODAL
                    }
                }
            ];
        case handlers.MACHINE_START_STIR_CANISTERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_STIR_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_STIR_ALL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_STIR_ALL_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_PURGE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_PURGE_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_PURGE_ALL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_PURGE_ALL_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_SMART_PURGE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_SMART_PURGE_DONE
                    }
                }
            ];
        case handlers.MACHINE_START_SMART_PURGE_ALL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_SMART_PURGE_ALL_DONE
                    }
                }
            ];
        case handlers.MACHINE_HISTORY_ACTIONS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_HISTORY_ACTIONS,
                    payload: {
                        historyActions: response.data
                    }
                }
            ];
        case handlers.GET_SPECTRO_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_CONFIGURATION,
                    payload: {
                        configuration: response.data
                    }
                }
            ];
        case handlers.SPECTRO_SELECTION_TEST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                if (next !== null) {
                    return [next];
                }

                return [];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_SELECT,
                    payload: {
                        result: false
                    }
                }
            ];
        case handlers.SPECTRO_CONNECTION_TEST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                if (next !== null) {
                    return [next];
                }

                return [];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                }
            ];
        case handlers.SPECTRO_IS_CONNECTED:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SPECTRO_SET_CONNECTION,
                        payload: {
                            connected: true
                        }
                    },
                    {
                        type: actionTypes.RCC_SPECTRO_REQUEST,
                        payload: {
                            type: methods.METHOD_SPECTRO_GET_CALLS
                        },
                        method: handlers.SPECTRO_GET_CALLS,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_CONNECTION,
                    payload: {
                        connected: false
                    }
                },
                {
                    type: actionTypes.RCC_SPECTRO_REQUEST,
                    payload: {
                        type: methods.METHOD_SPECTRO_START_CONNECT
                    },
                    method: handlers.SPECTRO_START_CONNECT,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.SET_SPECTRO_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (state.spectro.spectro.isConnected) {
                return [
                    {
                        type: actionTypes.RCC_SIMPLE_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_SPECTRO_CONFIGURATION
                        },
                        method: handlers.GET_SPECTRO_CONFIGURATION,
                        tabId: 0
                    },
                    messageHelper.getWarningMessageAction("flashMessage.spectroIsDisconnecting"),
                    {
                        type: actionTypes.RCC_SPECTRO_REQUEST,
                        payload: {
                            type: methods.METHOD_SPECTRO_START_DISCONNECT
                        },
                        method: handlers.SPECTRO_START_DISCONNECT,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            return [
                {
                    type: actionTypes.RCC_SIMPLE_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SPECTRO_CONFIGURATION
                    },
                    method: handlers.GET_SPECTRO_CONFIGURATION,
                    tabId: 0
                }
            ];
        case handlers.SPECTRO_START_CONNECT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.SPECTRO_EVENT_CONNECT_DONE
                    }
                }
            ];
        case handlers.SPECTRO_GET_CALLS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            let spectroMethods = rccHelper.processSpectroMethodList(response.data);

            let spectroRequests = [
                {
                    type: actionTypes.SAVE_SPECTRO_CALLS,
                    payload: {
                        methods: spectroMethods
                    }
                }
            ];

            if (spectroMethods[methods.METHOD_SPECTRO_GET_INFO] === true) {
                spectroRequests.push({
                    type: actionTypes.RCC_SPECTRO_REQUEST,
                    payload: {
                        type: methods.METHOD_SPECTRO_GET_INFO
                    },
                    method: handlers.SPECTRO_GET_INFO,
                    tabId: 0,
                    safe: false,
                    safer: false
                });
            }

            if (spectroMethods[methods.METHOD_SPECTRO_IS_CALIBRATED] === true) {
                spectroRequests.push({
                    type: actionTypes.RCC_SPECTRO_REQUEST,
                    payload: {
                        type: methods.METHOD_SPECTRO_IS_CALIBRATED
                    },
                    method: handlers.SPECTRO_IS_CALIBRATED,
                    tabId: 0,
                    safe: false
                });
            }

            if (spectroMethods[methods.METHOD_SPECTRO_GET_DIALOG] === true) {
                spectroRequests.push({
                    type: actionTypes.RCC_SPECTRO_REQUEST,
                    payload: {
                        type: methods.METHOD_SPECTRO_GET_DIALOG
                    },
                    method: state.module.gammaSoftware
                        ? handlers.SPECTRO_GET_DIALOG_AND_START_MEASURE
                        : handlers.SPECTRO_GET_DIALOG,
                    tabId: 0,
                    safe: false,
                    safer: false
                });
            }

            return spectroRequests;
        case handlers.SPECTRO_GET_INFO:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_INFO,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.SPECTRO_IS_CALIBRATED:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_CALIBRATED,
                    payload: {
                        calibrated: response.data
                    }
                }
            ];
        case handlers.SPECTRO_GET_DIALOG:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== undefined) {
                return [
                    {
                        type: actionTypes.SAVE_SPECTRO_DIALOG,
                        payload: {
                            dialog: modelHelper.createSpectroDialog(response.data)
                        }
                    },
                    {
                        type: actionTypes.OPEN_SPECTRO_DIALOG
                    }
                ];
            }

            return [];
        case handlers.SPECTRO_GET_DIALOG_AND_START_MEASURE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== undefined) {
                return [
                    {
                        type: actionTypes.SAVE_SPECTRO_DIALOG,
                        payload: {
                            dialog: modelHelper.createSpectroDialog(response.data)
                        }
                    },
                    {
                        type: actionTypes.OPEN_SPECTRO_DIALOG
                    }
                ];
            }

            if (state.spectro.spectro.validMethod(methods.METHOD_SPECTRO_START_MEASURE)) {
                return [
                    {
                        type: actionTypes.RCC_SPECTRO_REQUEST,
                        payload: {
                            type: methods.METHOD_SPECTRO_START_MEASURE
                        },
                        method: handlers.SPECTRO_START_MEASURE,
                        tabId: 0,
                        safe: false,
                        safer: false
                    }
                ];
            }

            return [];
        case handlers.SPECTRO_DIALOG_BUTTON_CLICK:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [];
            }

            return [];
        case handlers.SPECTRO_START_CALIBRATE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                        payload: {
                            id: response.sequence,
                            tabId: 0,
                            method: methods.SPECTRO_EVENT_CALIBRATE_DONE
                        }
                    }
                ];
            }

            return [];
        case handlers.SPECTRO_START_MEASURE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                        payload: {
                            id: response.sequence,
                            tabId: tabId,
                            method: methods.SPECTRO_EVENT_MEASURE_DONE,
                            next: next
                        }
                    }
                ];
            }

            return [];
        case handlers.RCC_PRINT_FORMULA_SILENT:
            if (response.result === resultCodes.RCC_RESULT_UNKNOWN_COMMAND) {
                return [messageHelper.getInfoMessageAction("flashMessage.printCannotBeCarriedOut")];
            }

            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (next !== null) {
                window.imageStore.addPrintImage(next, null);
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_ACTIVE_MODAL
                }
            ];
        case handlers.MACHINE_HISTORY_REFILLS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }
            return [
                {
                    type: actionTypes.SAVE_MACHINE_REFILL_HISTORY,
                    payload: {
                        data: response.data === undefined ? [] : response.data
                    }
                }
            ];
        case handlers.MACHINE_HISTORY_REFILLS_WITH_OFFSET:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_REFILL_HISTORY_WITH_OFFSET,
                    payload: {
                        data: response.data === undefined ? [] : response.data
                    }
                }
            ];
        case handlers.RELOAD_MACHINE_CAN_BATCH_NUMBERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_ALL_BATCH_NUMBERS,
                    payload: {
                        batchNumbers: response.data
                    }
                }
            ];
        case handlers.MACHINE_GET_UFI_CODES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CANISTER_UFI_CODES,
                    payload: {
                        data: response.data.reverse()
                    }
                }
            ];
        case handlers.TO_DISPENSE_VALIDATE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_FORMULA_VALIDATION,
                    payload: {
                        result: response.data
                    }
                }
            ];
        case handlers.TO_DISPENSE_VALIDATE_AND_LOAD_MANUAL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (!Array.isArray(response.data)) {
                return [];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_FORMULA_VALIDATION,
                    payload: {
                        result: response.data
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_MANUAL_FORMULA,
                        params: {
                            formula:
                                state.toDispense.activeOrder === null || state.toDispense.activeOrder.formula === null
                                    ? []
                                    : state.toDispense.activeOrder.formula.getColorantVolumes()
                        }
                    },
                    method: handlers.MACHINE_MANUAL_FORMULA_TO_DISPENSE,
                    tabId: tabId,
                    safe: true
                }
            ];
        case handlers.MACHINE_GET_CANISTER_IMAGE:
            if (response.result !== resultCodes.RCC_RESULT_OK || response.data === undefined) {
                window.imageStore.setMachineCanister(null);

                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            window.imageStore.setMachineCanister({
                type: response.data.mimeType,
                img: response.data.data
            });

            return [
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.MACHINE_SET_CANISTER_BARCODE:
            if (response.result !== resultCodes.RCC_RESULT_OK || !response.data) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BARCODE,
                    payload: {
                        barcode: ""
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: true
                }
            ];
        case handlers.MACHINE_SET_CANISTER_THRESHOLD:
            if (response.result !== resultCodes.RCC_RESULT_OK || !response.data) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_CANISTERS
                    },
                    method: handlers.MACHINE_CANISTERS,
                    tabId: 0,
                    safe: true
                }
            ];
        case handlers.SPECTRO_SELECTION_MANUAL_TEST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SET_SELECT,
                    payload: {
                        result: response.data
                    }
                }
            ];
        case handlers.MACHINE_GET_CANISTER_BY_BARCODE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.MACHINE_SAVE_VALIDATION_CANISTER,
                    payload: {
                        result: response.data === undefined ? null : response.data
                    }
                }
            ];
        case handlers.MACHINE_GET_CANISTER_BY_BARCODE_TEST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === undefined) {
                return [
                    {
                        type: actionTypes.SAVE_BARCODE_ITEM,
                        payload: {
                            itemType: -1,
                            item: null
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_BARCODE_ITEM,
                    payload: {
                        itemType: -2,
                        item: modelHelper.buildCanisterObject(response.data)
                    }
                }
            ];
        case handlers.MACHINE_START_CANISTER_REFILL:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.CANISTER_LEVELS_MODAL
                    }
                }
            ];
        case handlers.PRINTER_GET_TEMPLATES_LIST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_TEMPLATES_LIST,
                    payload: {
                        templateList: response.data
                    }
                }
            ];
        case handlers.PRINTER_START_JPG_EXPORT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: tabId,
                        method: methods.PRINTER_EVENT_JPG_EXPORT_DONE,
                        next: next
                    }
                }
            ];
        case handlers.PRINTER_START_PDF_EXPORT:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data !== true) {
                return [];
            }
            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: tabId,
                        method: methods.PRINTER_EVENT_PDF_EXPORT_DONE
                    }
                }
            ];
        case handlers.MACHINE_BACKUP_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            windowService.openSaveDialog(response.data.data, "dispenser.zip");

            return [];
        case handlers.MACHINE_PURGE_RULES_LIST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SMART_PURGE_RULES_LIST,
                    payload: {
                        smartPurgeRulesList: response.data
                    }
                }
            ];
        case handlers.MACHINE_PURGE_RULE_ADD:
        case handlers.MACHINE_PURGE_RULE_UPDATE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_PURGE_RULES_LIST
                    },
                    method: handlers.MACHINE_PURGE_RULES_LIST,
                    tabId: 0,
                    safe: true
                }
            ];
        case handlers.MACHINE_GET_PURGE_STATS:
        case handlers.MACHINE_GET_DISPENSE_STATS:
        case handlers.MACHINE_GET_ALL_STATS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PURGE_STATS,
                    payload: {
                        purgeStats: response.data
                    }
                }
            ];
        case handlers.MACHINE_MANUAL_FORMULA:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MANUAL_FORMULA,
                    payload: {
                        tabId: tabId,
                        formula: response.data
                    }
                }
            ];
        case handlers.MACHINE_MANUAL_FORMULA_MY_ORDERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MANUAL_FORMULA_MY_ORDERS,
                    payload: {
                        formula: response.data
                    }
                }
            ];
        case handlers.MACHINE_MANUAL_FORMULA_TO_DISPENSE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MANUAL_FORMULA_TO_DISPENSE,
                    payload: {
                        formula: response.data
                    }
                }
            ];
        case handlers.MACHINE_COLORANT_PREDICTION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === undefined) {
                return [];
            }

            return [stockActions.setPredictionForColorantPackageStock(response.data)];
        case handlers.MACHINE_GET_AUTOTASKS:
        case handlers.MACHINE_START_AUTOTASK:
        case handlers.MACHINE_AUTOTASK_DELETE:
        case handlers.MACHINE_AUTOTASK_ADD_GENERIC:
        case handlers.MACHINE_AUTOTASK_UPDATE_GENERIC:
            return autotaskService.processWebsocketResponse(tabId, method, response);
        case handlers.PREPARE_FILE_CHANNEL_ALL_STATS_DATA:
        case handlers.PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA:
        case handlers.PREPARE_FILE_CHANNEL_PURGE_STATS_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.PROGRESS_BAR_MODAL
                        }
                    }
                ];
            }

            let fileNameLabel = null;

            switch (method) {
                case handlers.PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA:
                    fileNameLabel = "DISPENSE";
                    break;
                case handlers.PREPARE_FILE_CHANNEL_PURGE_STATS_DATA:
                    fileNameLabel = "PURGE";
                    break;
                default:
                    fileNameLabel = "CONSUMPTION";
                    break;
            }

            let newDownloadingFile = modelHelper.mapDownloadingFileToObject(
                response.data.id,
                fileNameLabel,
                "xlsx",
                response.data.length
            );

            if (newDownloadingFile === null) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.PROGRESS_BAR_MODAL
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.RCC_SAVE_FILE_INFORMATION,
                    payload: {
                        downloadingFile: newDownloadingFile
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_PREPARE_FILE_BYTES,
                        params: {
                            id: newDownloadingFile.id,
                            bytesFrom: 0,
                            bytesTo: newDownloadingFile.downloadedLength
                        }
                    },
                    method: handlers.PREPARE_FILE_BYTES,
                    tabId: 0
                }
            ];
        case handlers.PREPARE_FILE_BYTES:
            if (!responseHelper.isPrepareFileFormatValid(response)) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.PROGRESS_BAR_MODAL
                        }
                    }
                ];
            }

            let preparedFile = state.rcc.downloadingFileList.find((item) => item.id === response.data.id);

            if (preparedFile === undefined) {
                return [
                    {
                        type: actionTypes.RCC_PREPARE_FILE_ERROR,
                        payload: {
                            preparedFileId: response.data.id
                        }
                    }
                ];
            }

            windowService.appendFileData(preparedFile.filePath, response.data.bytes, (error) => {
                if (error === null) {
                    window.storeProvider.dispatchAction({
                        type: actionTypes.RCC_PREPARE_FILE_SUCCESS,
                        payload: {
                            preparedFile: preparedFile
                        }
                    });
                } else {
                    windowService.logError("Download error ", error.message);

                    window.storeProvider.dispatchAction({
                        type: actionTypes.RCC_PREPARE_FILE_ERROR,
                        payload: {
                            preparedFileId: response.data.id
                        }
                    });
                }
            });

            return [];
        case handlers.GET_SPECTRO_XRITE_MODELS:
        case handlers.GET_SPECTRO_COM_PORTS:
            return spectroService.processWebsocketResponse(tabId, method, response);
        default:
            return initService.processWebsocketResponse(tabId, method, response, next, state);
    }
};
